module.exports = __webpack_public_path__ + "static/media/Bomb_3.2ba13b91.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/Bomb_3.mp3
// module id = 866
// module chunks = 0